import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const CATEGORY_BADGE = {
  restoration: "CUSTOM BUILD",
  "3d_design": "3D DESIGN",
  coatings: "SPECIALTY COATINGS",
};

export default function ProjectCard({ project, index = 0 }) {
  return (
    <div
      className="opacity-0 animate-[fadeIn_0.5s_ease-out_forwards]"
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <Link 
        to={`/gallery/${project.id}`}
        className="block project-card group border border-white/10 bg-zinc-900/50 overflow-hidden"
        data-testid={`project-card-${project.id}`}
      >
        {/* Image */}
        <div className="aspect-[4/3] overflow-hidden">
          <img 
            src={project.images?.[0] || "https://images.unsplash.com/photo-1581139196553-2d6c0c9ff634"}
            alt={project.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Category Badge */}
          <span className="inline-block font-mono text-xs tracking-[0.2em] uppercase text-amber-500 mb-2">
            {CATEGORY_BADGE[project.category] || CATEGORY_BADGE.coatings}
          </span>

          {/* Title */}
          <h3 className="font-heading text-2xl text-white mb-2 tracking-tight group-hover:text-amber-500 transition-colors">
            {project.title}
          </h3>

          {/* Vehicle Info */}
          {project.year && project.make && (
            <p className="text-zinc-400 font-body text-sm mb-3">
              {project.year} {project.make} {project.model}
            </p>
          )}

          {/* View Link */}
          <div className="flex items-center gap-2 text-zinc-400 group-hover:text-amber-500 transition-colors">
            <span className="font-mono text-xs tracking-wide">VIEW PROJECT</span>
            <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </div>
        </div>
      </Link>
    </div>
  );
}
